"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchTrialState = void 0;

var _getAvailableTrials = require("self-service-api/api/getAvailableTrials");

var _ActionTypes = _interopRequireDefault(require("../constants/ActionTypes"));

var fetchTrialState = function fetchTrialState() {
  return function (dispatch) {
    dispatch({
      type: _ActionTypes.default.TRIAL_STATE_REQUESTED
    });
    (0, _getAvailableTrials.getAvailableTrials)().then(function (trialState) {
      dispatch({
        type: _ActionTypes.default.TRIAL_STATE_RECEIVED,
        payload: trialState
      });
    }).catch(function () {
      dispatch({
        type: _ActionTypes.default.TRIAL_STATE_FAILED
      });
    });
  };
};

exports.fetchTrialState = fetchTrialState;